// tslint:disable
export namespace UsersApi {
  export enum AppDto {
    admin = 'admin',
    borrower = 'borrower',
    lender = 'lender',
    lead = 'lead',
    custom = 'custom',
    portfolioAnalysis = 'portfolioAnalysis',
    businessFlowVisualizer = 'businessFlowVisualizer',
  }
  export interface BankAccountInfoDto {
    id?: string;
    name?: string;
    bankAccountNumber?: string;
  }
  export enum BorrowerTitleDto {
    Trader = 'Trader',
    TraderManager = 'TraderManager',
    Manager = 'Manager',
    BackOffice = 'BackOffice',
    Executive = 'Executive',
  }
  export interface LegalEntityBaseDto {
    id?: string;
    displayName?: string;
  }
  export interface LegalEntityDto extends UsersApi.LegalEntityBaseDto {
    currency?: string;
    type?: UsersApi.LegalEntityTypesDto;
    userRole?: UsersApi.UserRolesDto;
    priorApprovalType?: UsersApi.PriorApprovalTypeDto;
    configurations?: UsersApi.LenderConfigurationsDto;
    allowManualUpload?: boolean;
    allowManualUploadBankAccounts?: Array<UsersApi.BankAccountInfoDto>;
    displaySettings?: boolean;
    parentId?: string;
    isSlTech?: boolean;
    isLeaf?: boolean;
  }
  export enum LegalEntityTypesDto {
    Lender = 'Lender',
    Borrower = 'Borrower',
    Lead = 'Lead',
  }
  export interface LenderConfigurationsDto {
    canEditLendingTerms?: boolean;
    canApproveLegalEntities?: boolean;
    allowSinglePortfolio?: boolean;
    autoSubstitution?: boolean;
    displayLenderDashboardClientManagementTool?: boolean;
    disablePvlSettingChange?: boolean;
    enableSmartPortfolioInsightsPage?: boolean;
  }
  export enum PriorApprovalTypeDto {
    Auto = 'Auto',
    Manual = 'Manual',
  }
  export enum RateGroupDto {
    GC = 'GC',
    Warm = 'Warm',
    Special = 'Special',
    DeepSpecial = 'DeepSpecial',
  }
  export enum SecurityTypeDto {
    Stock = 'Stock',
    Bond = 'Bond',
    ETF = 'ETF',
  }
  export enum SettlementDateDto {
    T0 = 'T0',
    T1 = 'T1',
    T2 = 'T2',
  }
  export interface TrackingConsentDto {
    cusip?: boolean;
    hotjar?: boolean;
    heap?: boolean;
    pendo?: boolean;
    mixpanel?: boolean;
  }
  export interface UpdateUserPhoneNumberRequest {
    phoneNumber?: string;
  }
  export interface UpdateUserSettingsRequest {
    countries?: Array<string>;
    securityTypes?: Array<UsersApi.SecurityTypeDto>;
    defaultLegalEntity?: string;
    trackingConsent?: UsersApi.TrackingConsentDto;
    borrowerTitle?: UsersApi.BorrowerTitleDto;
    hasSupply?: boolean;
    defaultSettlementDate?: UsersApi.SettlementDateDto;
    rateGroups?: Array<UsersApi.RateGroupDto>;
    disableEmailNotifications?: boolean;
    disablePushRecommendations?: boolean;
  }
  export interface UserDto {
    id?: string;
    userName?: string;
    displayName?: string;
    lastSeen?: string;
    phoneNumber?: string;
    legalEntities?: Array<UsersApi.LegalEntityBaseDto | UsersApi.LegalEntityDto>;
    availableApplications?: Array<string>;
    userSettings?: UsersApi.UserSettingsDto;
  }
  export enum UserRolesDto {
    Admin = 'Admin',
    Ops = 'Ops',
    Viewer = 'Viewer',
    Sales = 'Sales',
  }
  export interface UserSettingsDto {
    countries?: Array<string>;
    securityTypes?: Array<UsersApi.SecurityTypeDto>;
    defaultLegalEntity?: string;
    trackingConsent?: UsersApi.TrackingConsentDto;
    borrowerTitle?: UsersApi.BorrowerTitleDto;
    hasSupply?: boolean;
    defaultSettlementDate?: UsersApi.SettlementDateDto;
    rateGroups?: Array<UsersApi.RateGroupDto>;
    lenderRecommendationsEnabled?: boolean;
    disableEmailNotifications?: boolean;
  }
}
